module.exports = __webpack_public_path__ + "img/equipos-moviles-img-12.29c7c53f.jpg";